import { defineStore } from "pinia";
import { ref } from "vue";
import api from "../services/api";

export const useGamesStore = defineStore("games", () => {
  const games = ref([]);
  const pagination = ref({ page: 1, limit: 20, total: 0, totalPages: 0 });
  const loading = ref(false);

  async function fetchGames(page = 1) {
    loading.value = true;
    try {
      const { data } = await api.get("/games", { params: { page } });
      games.value = data.games;
      pagination.value = data.pagination;
    } catch (error) {
      console.error("Failed to fetch games:", error);
    } finally {
      loading.value = false;
    }
  }

  async function uploadGame(gameData) {
    const { data } = await api.post("/games", gameData);
    return data;
  }

  async function getGame(gameId) {
    const { data } = await api.get(`/games/${gameId}`);
    return data.game;
  }

  async function deleteGame(gameId) {
    await api.delete(`/games/${gameId}`);
    games.value = games.value.filter((g) => g.gameId !== gameId);
  }

  return {
    games,
    pagination,
    loading,
    fetchGames,
    uploadGame,
    getGame,
    deleteGame,
  };
});
